"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amIFollowing = exports.getUsersData = exports.getUserData = void 0;
var axios_1 = __importDefault(require("axios"));
function getUserData(_a) {
    var id = _a.id, token = _a.token;
    return token
        ? axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/").concat(id, "?_embed"), {
            headers: {
                Authorization: 'Bearer' + token,
                'Content-Type': 'application/json'
            }
        })
        : axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/").concat(id, "?_embed"));
}
exports.getUserData = getUserData;
function getUsersData(ids) {
    if (ids.length === 1)
        return getUserData(ids[0]);
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users?include=").concat(ids.join(','), "&_embed"));
}
exports.getUsersData = getUsersData;
var amIFollowing = function (userId, targetId) {
    return axios_1.default
        .get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/is/").concat(userId, "/following/").concat(targetId))
        .then(function (response) { return response.data; });
};
exports.amIFollowing = amIFollowing;
